import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Pagination from "@mui/material/Pagination";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
// import { myWordsQuery } from "../../../../../validations/myWordsValidation";
import { getShortListOfWordGroups } from "../../../../../../services/userSaveWordApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../../utils/utilsFunctions";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function GroupOfWordsQuery(props) {
  const { handleGroupList } = props;

  const initialValues = {
    nameOfgroup: "",
  };

  const onSubmit = (values, props) => {
    let data = {
      nameOfgroup: values.nameOfgroup,
    };
    getListOfWordGroupsBack(data);
  };

  const getListOfWordGroupsBack = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      const response = await getShortListOfWordGroups(data)
      let res = checkResponseData(response);
      toast.update(toastMsg, { render: res["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      if (res["data"] && res["data"]["data"]) {
        let allGroup = [];
        res["data"]["data"].forEach((grp) => {
          allGroup.push(grp["nameOfgroup"]);
        });
        // console.log(allGroup);
        handleGroupList(allGroup);
      }
      // toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false,autoClose:3000 });

    } catch (error) {
      console.log(error);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }
  };

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        // validationSchema={myWordsQuery}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"نام گروه"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="nameOfgroup"
                        label="نام گروه"
                        placeholder="نام گروه"
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="nameOfgroup" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 2 }}
              color="success"
            >
              جست و جو
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
